import React from 'react'
import styled from 'styled-components/native'
import { faTicket } from '@fortawesome/free-solid-svg-icons'
import { ProximaNova, FaIcon } from '../../../../App/Components'

type Props = {
  isShowPrice: boolean
  price?: number
  fontColor?: string
  hasPunchCard?: boolean
}

const PriceText = styled(ProximaNova)<{ color: string }>`
  font-size: 1em;
  width: 50%;
  color: ${({ color }) => color || '#fff'};
`

export const ActivityPrice = ({
  isShowPrice,
  price,
  fontColor,
  hasPunchCard,
}: Props) => {
  if (hasPunchCard) {
    return (
      <PriceText color={fontColor}>
        <FaIcon size="sm" icon={faTicket} color={fontColor} />
      </PriceText>
    )
  }

  if (!isShowPrice || !price) {
    return null
  }

  return <PriceText color={fontColor}>{`€${price}`}</PriceText>
}
